import { graphOverviewAxisFilter } from './';
export const graphOverviewFilterFill = (theme, parameters) => {
  const overviewAxisFilter = graphOverviewAxisFilter(theme, parameters);
  return {
    fillColor: overviewAxisFilter.fillColor,
    fillTransparency: overviewAxisFilter.fillTransparency // TODO: update doc fillTransparency vs transparency
  };
};
//# sourceMappingURL=graphOverviewFilterFill.js.map